// Unused
export const TISL_REGISTER_DATA = {
  entry: {
    _version: '',
    uid: '',
    name: 'ចាប់អារម្មណ៍បើកបរសាកល្ប<br>ងរថយន្ត ISUZU',
    img: {
      url: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt7bf878ad374766e8/62cc1dbf07121b35836b4e78/bg-register-mobile.jpg',
    },
    image_detail: {
      url: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt3d9dbc5976369ac0/62cc1e0a291ece3ea016b2a7/bg-register.jpg',
    },
    metatag: {
      title: 'ចាប់អារម្មណ៍បើកបរសាកល្បងរថយន្ត - Isuzu TIS Cambodia',
      description:
        'ចូលបំពេញព័ត៌មានរបស់អ្នក ដើម្បីឱ្យក្រុមការងាររអាចទាក់ទងអ្នកឆាប់ៗ',
      img: {
        url: null,
      },
    },
  },
  model: 'pickup',
  campaign: '',
};
